import m from "./../../../dist/es2015/locales/ja_JP.js";
export const am5locales_ja_JP = m;